//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbBanner from '@/elements/editorial/rb-banner/rb-banner.vue'
import { TABLET, MOBILE } from '@/scripts/constants/media-query'
export default {
  name: 'rb-banner-tile',
  components: {
    RbBanner,
  },
  props: {
    /*
     * Column Props
     * pillPosition // options: [top-left, top-center]
     * pillMobilePosition // options: [top-left, top-center]
     * isCtaOverlappingOnMobile // MUST be true
     * contentPosition // options: [bottom-center, bottom-left]
     * textAlign= // options: [center, left] If contentPosition is bottom-center, textAlign should be center , If contentPosition is bottom-left, textAlign should be left
     */
    bannerSize: {
      type: Number,
      default: 1, // options: [1, 2, 3]
    },
  },
  computed: {
    getBannerTileSize() {
      return [
        {
          'rb-banner-tile--small': this.bannerSize === 1,
          'rb-banner-tile--medium': this.bannerSize === 2,
          'rb-banner-tile--large': this.bannerSize === 3,
        },
      ]
    },
    pillCursor() {
      return this.$attrs['is-v-cta-directive-enabled'] ? 'cursor' : 'arrow'
    },
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
    pillLabel() {
      if (!this.$attrs.pill) {
        return ''
      }

      if (this.isMobile && this.bannerSize === 1) {
        return ''
      }

      return this.$attrs.pill
    },
  },
}
